<template>
  <el-dialog title="修改" :visible.sync="formVisible" :close-on-click-modal="false" width="800px">
    <el-form ref="dataForm" label-position="right" :rules="formRules" :model="form" size="small" label-width="130px">
      <el-form-item label="付款凭证：" prop="payVoucherUrl" class="width100">
        <div class="upload-box flexs">
          <div class="upload-img">
            <!-- <el-upload :action="uploadUrl" list-type="picture-card" :multiple="false" limit="3"
              :on-success="handleSuccess" :on-remove="handleRemove">
              <i class="el-icon-plus"></i>
            </el-upload> -->
            <el-image style="width: 78px; height: 78px;margin-right:5px" :src="item.payImg" :preview-src-list="[item.payImg]" v-for="item in form.payOrderNums" :key="item.id"></el-image>
          </div>
          <div class="upload-input">
            <div class="item" v-for="(item,index) in form.payOrderNums" :key="index">
              <el-button type="primary" @click="getOcrTest(index)" v-if="!item.ocrContent" style="width: 120px;" :disabled="isFinanceMode">通过OCR提取文字</el-button>
              <el-popover v-else placement="top-start" title="" width="400" trigger="hover" :content="item.ocrContent">
                <el-button slot="reference">查看OCR提取的信息</el-button>
              </el-popover>
              <div style="display: flex;align-items: center;">
                <el-form-item :prop="'payOrderNums.' + index + '.payBank'" :rules="{ required: true, message: '请选择收款银行', trigger: 'change' }" class="cus-sty">
                  <el-select v-model="item.payBank" placeholder="请选择收款银行" :disabled="isFinanceMode" filterable>
                    <el-option :label="it.bankName" :value="it.bankName" v-for="(it,idx) in enabledConfigList" :key="idx"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :prop="'payOrderNums.' + index + '.payNum'" :rules="{ required: true, message: '请输入支付单号', trigger: 'blur' }" class="cus-sty">
                  <el-input v-model="item.payNum" placeholder="请输入支付单号" :disabled="isFinanceMode"></el-input>
                </el-form-item>
              </div>
              <div style="display: flex;align-items: center;">
                <el-form-item :prop="'payOrderNums.' + index + '.payMoney'" :rules="{ required: true, message: '请输入付款金额', trigger: 'blur' }" class="cus-sty">
                  <el-input v-model="item.payMoney" placeholder="请输入付款金额"></el-input>
                </el-form-item>
                <el-form-item :prop="'payOrderNums.' + index + '.payTime'" :rules="{ required: true, message: '请选择付款日期', trigger: 'change' }" class="cus-sty">
                  <el-date-picker v-model="item.payTime" size="small" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="付款日期" :disabled="isFinanceMode"></el-date-picker>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()" :loading="isLoading">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import sysDataconstantApi from '@/api/config/sysDataconstant'
import rechargeRecordApi from '@/api/recharge/rechargeRecord'
import customerRegistrationApi from '@/api/cust/customerRegistration'
import customerRegistrationPayApi from '@/api/cust/customerRegistrationPay'
function initFormBean() {
  const formBean = {
    payOrderNums: []
  }
  return formBean
}

export default {
  props: {
    sectionList: Array,
    popType: Number,
    mode: {
      type: String,
      default: 'recharge' // 默认值为recharge，保持原有功能
    }
  },
  data() {
    return {
      uploadUrl: process.env.VUE_APP_BASE_API + '/sys/cosUploader/upload',
      form: initFormBean(),
      formVisible: false,
      isLoading: false,
      uploadImgs: [],
      id: '',
      configList: []
    }
  },
  created() {
    this.getConfig()
  },
  computed: {
    // 是否为财务审核模式（只能修改金额）
    isFinanceMode() {
      return this.mode === 'finance'
    },
    // 仅显示已启用的银行
    enabledConfigList() {
      return (this.configList || []).filter(it => String(it.isEnable) === '1')
    }
  },
  methods: {
    getConfig() {
      sysDataconstantApi.fetchBatchCode({
        code: 'lineUpMoneyBankType'
      }).then(({
        data
      }) => {
        this.configList = data.list[0].content ? JSON.parse(data.list[0].content) : []
        // console.log("配置: ", this.configList);
      })
    },
    handleBlur(item, index) {
      // console.log('item: ',item);
      let query = {
        ...item
      }
      query.state = 1
      query.dataType = 0
      delete query.createdBy
      delete query.createdTime
      customerRegistrationApi.setPayNum([query]).then(res => {
        this.formVisible = false
        this.$emit('created')
      }).catch(res => {
        this.isLoading = false
      })
    },
    /**
     * 识别支付单号
     */
    getOcrTest(index) {
      return rechargeRecordApi.accurateOCR({ imageUrl: this.payOrderNums[index].payImg })
        .then(res => {
          this.form.payOrderNums[index].ocrContent = res.data
        })
    },
    resetForm() {
      this.isLoading = false
      this.form = initFormBean()
      this.uploadImgs = []
    },
    handleCreate(row) {
      let obj = JSON.parse(JSON.stringify(row))
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
        this.form.payOrderNums = [obj]
      })
    },
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          this.isLoading = true;
          let payOrderNums = this.form.payOrderNums[0]
          let query = {
            id: payOrderNums.id,
            payBank: payOrderNums.payBank,
            payNum: payOrderNums.payNum,
            payMoney: payOrderNums.payMoney,
            payTime: payOrderNums.payTime,
            payMethod: payOrderNums.payMethod
          }
          customerRegistrationPayApi.update(query).then(res => {
            this.isLoading = false
            this.formVisible = false
            this.$emit('created')
          }).catch(res => {
            this.isLoading = false
          })
        }
      });
    },
  }
}
</script>
<style lang="scss" scoped>
.cus-sty {
  width: 220px;
  margin-bottom: 2px;
  margin-right: 2px;
}
.tip-box {
  margin-bottom: 20px;

  i {
    font-size: 24px;
    margin-right: 10px;
    color: #e6a23c;
  }
}
.upload-box {
  align-items: flex-start;
  .upload-img {
    width: 80px;
    margin-right: 10px;
  }
  .upload-input {
    width: calc(100% - 80px);
    .item {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      min-height: 70px;
      margin-bottom: 18px;
    }
  }
}
::v-deep .el-select {
  width: 100%;
}
::v-deep .el-cascader {
  width: 100%;
}
::v-deep .el-upload-list__item,
::v-deep .el-upload--picture-card {
  width: 70px;
  height: 70px;
  line-height: 75px;
}
::v-deep .el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none;
}
</style>
